<template>
  <div class="d-flex">
    <span class="flex-grow-0">Struktur testen:</span>
    <select class="flex-grow-1 ms-2" @change="applyStructure($event)">
      <option
        v-if="!$page.props.user.structures.includes($page.props.structure)"
        :value="$page.props.structure"
        selected
      >
        {{ $page.props.structure }}
      </option>
      <option
        v-for="structure in $page.props.user.structures"
        :key="structure"
        :value="structure"
        :selected="$page.props.structure === structure"
      >
        {{ structure }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  emits: [],
  setup() {
    const applyStructure = async (event) => {
      window.location = '/user-settings/apply/structure/' + event.target.value;
    };

    return {
      applyStructure,
    };
  },
};
</script>
